import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogOverlay,
  Button,
} from '@chakra-ui/react';
import { useRef } from 'react';
import { copy } from '../copy';

type Props = {
  isOpen: boolean;
  onCancel: () => void;
  onConfirm: () => void;
};

export function ExitUnsavedKeyDialog({ isOpen, onCancel, onConfirm }: Props) {
  const cancelRef = useRef<HTMLButtonElement>(null);
  return (
    <AlertDialog
      isOpen={isOpen}
      onClose={onCancel}
      leastDestructiveRef={cancelRef}
      isCentered
    >
      <AlertDialogOverlay>
        <AlertDialogContent borderRadius="12px">
          <AlertDialogHeader fontWeight={700}>
            {copy.exitUnsaved.title}
          </AlertDialogHeader>
          <AlertDialogBody>{copy.exitUnsaved.body}</AlertDialogBody>
          <AlertDialogFooter gap={2}>
            <Button ref={cancelRef} onClick={onCancel}>
              {copy.exitUnsaved.cancel}
            </Button>
            <Button colorScheme="red" onClick={onConfirm}>
              {copy.exitUnsaved.confirm}
            </Button>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialogOverlay>
    </AlertDialog>
  );
}
